import { ReferenceField, TextField } from "react-admin";
import * as React from "react";
import { SourceAircraftType } from "../../../Pages/Admin/AircraftType";

const AircraftTypeField = props => {
  return (
    <ReferenceField label="Aircraft Type" source="aircraftTypeId" reference={SourceAircraftType} {...props}>
      <TextField source="aircraftTypeCode" />
    </ReferenceField>
  );
};

export default AircraftTypeField;
